<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>
              <i class="fa fa-align-justify"></i> Gestion des types de document
            </strong>
          </div>
          <b-card-body>
            <v-client-table :columns="columns" :data="allTypes" :options="options" ref="categories_table">
              <div slot="afterFilterWrapper" v-if="canManageType">
                <b-button type="button" @click="editType()" size="md" variant="success" class="float-right">
                  <i class="fa fa-plus"></i> Créer un type
                </b-button>
              </div>
              
              <div v-if="props.row.created_at" slot="created_at" slot-scope="props" class="slot-date">
                <span class="badge badge-success p-2">{{ formatDate(props.row.created_at) }}</span>
              </div>
              <div v-if="props.row.categorie_id" slot="categorie_id" slot-scope="props">
                {{ !isEmpty(props.row.categorie) ? props.row.categorie.libelle : '' }}
              </div>
              <div v-if="canManageType" slot="action" slot-scope="props" class="w-auto">
                <i v-b-tooltip.hover title="Modifier la catégorie" class="mr-2 fa fa-edit fa-1_5x text-primary clickable" @click="editType(props.row)"></i>
                <i v-b-tooltip.hover title="Supprimer la catégorie" class="fa fa-trash fa-1_5x text-danger clickable" @click="deleteType(props.row.id)"></i>
              </div>
            </v-client-table>
            <b-row>
              <b-col sm="12" v-if="canManageType">
                <b-button type="button" @click="editType()" size="md" variant="success" class="float-right">
                  <i class="fa fa-plus"></i> Créer un type
                </b-button>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <modal-type :selectedType="selectedTypeToModify" :categoryOptions="categoryOptions"></modal-type>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '@/utils/auth';
import {espaceBibliothequeRules as rules, hasRule} from '@/utils/rulesHelper';
import {isEmpty} from '@/utils/fileHelper';
import {formatDate} from '@/utils/communHelper';
import modalType from './ModalType';

export default {
  components: {
    modalType,
  },
  data() {
    return {
      isEmpty,
      formatDate,
      libelle: '',
      libelle_technique: '',
      categorie_id: '',
      modalTitle: 'Création d\'un type de document',
      // typeId: null,
      selectedTypeToModify: null,
      selectedCategory: null,
      allCategories: [],
      categoryOptions: [],
      allTypes: [],
      columns: [
        'created_at',
        'libelle',
        'libelle_technique',
        'categorie_id',
        'action'
      ],
      options: {
        headings: {
          created_at: 'Date de création',
          libelle: 'Libellé',
          libelle_technique: 'Libellé technique',
          categorie_id: 'Categorie',
          action: ''
        },
        columnsClasses: {
          created_at: "column-xs",
        },
        sortable: ['libelle'],
        filterable: ['libelle'],
        perPage: 10,
        perPageValues: [10, 50, 100],
        texts: {
          filterPlaceholder: 'Libellé'
        },
        orderBy: { column: 'created_at', ascending: false }
      },
      errors: {
        libelle: '',
        libelle_technique: '',
        categorie_id: '',
      }
    }
  },
  async created() {
    await this.getCategories();
    this.getTypes();

    this.$event.on('refresh-type-document', () => {
      this.getTypes();
      this.selectedTypeToModify = null;
    });
  },
  methods: {
    getTypes() {
      this.$store.commit("IS_LOADING", true);
      let self = this;
      this.$axios
        .get('/espaceBibliotheque/types')
        .then(response => {
          this.allTypes = response.data.types;
          this.$store.commit("IS_LOADING", false);
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
              position: "top",
              type: "warning",
              title: "Attention !!",
              text: 'Une erreur est survenue pendant la récupération des catégories de document. Si le problème persiste contactez le support DOSI.',
              showConfirmButton: false,
              timer: 5000
            });
        });
    },
    getCategories() {
      return new Promise((resolve, reject) => {
      let self = this;
      this.$axios
        .get('/espaceBibliotheque/categories')
        .then(response => {
          this.allCategories = response.data.categories;
          for (let row of response.data.categories) {
            this.categoryOptions.push({text: row.libelle, value: row.id});
          }
          resolve();
        })
        .catch(function(error) {
          resolve();
          self.$swal({
              position: "top",
              type: "warning",
              title: "Attention !!",
              text: 'Une erreur est survenue pendant la récupération des catégories de document. Si le problème persiste contactez le support DOSI.',
              showConfirmButton: false,
              timer: 5000
            });
        });
      })
    },
    editType(type) {
      if (!isEmpty(type)) {
        this.selectedTypeToModify = type;
      }

      this.$bvModal.show('modal-type');
    },
    deleteType(typeId) {
      let self = this;
      this.$swal.fire({
        title: 'Êtes-vous sûr?',
        text: "Voulez-vous vraiment supprimer ce Type ?",
        type: 'warning',
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonColor:"#ff1744",
        confirmButtonText: 'Annuler',
        cancelButtonText: 'Supprimer',
        }).then((result) => {
          if (!result.value) {
            this.$store.commit('IS_LOADING', true)
            this.$axios
            .delete("/espaceBibliotheque/type/delete/"+typeId)
            .then(response => {
              this.$store.commit('IS_LOADING', false)
              this.$swal({ position: 'top', type: 'success', title:'Suppression avec succès', text:'Le type a bien été supprimé',showConfirmButton: false, timer: 5000})
              this.getTypes()
            })
            .catch(function(error){
              self.$store.commit('IS_LOADING', false);
              let text = 'Une erreur est survenue pendant la suppression du type, si le problème persiste merci de contacter le support DOSI';
              if (!isEmpty(error) && error.response && error.response.status === 403) {
                text = error.response.data.message;
              }
              self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text: text,showConfirmButton: false, timer: 10000})
            })
          }
        })
    },
    canManageType() {
      return hasRule(rules.CAN_MANAGE_TYPE);
    },
  }
}
</script>

<style>
  .small-action {
    width:  5%;
  }
</style>
